import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { ORDERS_QUERY } from './mutations';
import SEO from '../seo';

import Wrapper from '../elements/wrapper';
import { TransitionMixin } from '../helpers';

const OrdersContainer = styled.div`
    .title-container {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #000;
        padding-bottom: 20px;

        h2 {
            margin: 0;
            font-size: 1.8rem;
            color: #0f1212;
            font-weight: 800;
            font-family: neue-kabel, sans-serif;
        }

        .btn-container {
            flex: 1;
            text-align: right;

            a {
                color: #fff;
                background-color: #f74d33;
                font-weight: bold;
                text-decoration: none;
                display: inline-block;
                line-height: 1;
                max-width: 160px;
                width: 100%;
                text-align: center;
                padding: 10px 0;
                border-radius: 5px;
                font-weight: 800;
                font-family: neue-kabel, sans-serif;
                border: 1px solid #f74d33;
                ${TransitionMixin('.25s')};

                &:hover {
                    background-color: #fff;
                    color: #f74d33;
                }
            }
        }
    }
    .table-container {
        .no-orders-container {
            padding: 20px 0;
        }

        table {
            thead {
                tr {
                    th {
                        border-bottom: 1px solid #000;
                        color: #000000;
                    }
                }
            }
            tbody {
                tr {
                    td {
                        font-size: 0.9rem;
                        color: #000;
                        a {
                            color: #702716;
                            ${TransitionMixin('.25s')}
                            &:hover {
                                opacity: 0.7;
                            }
                        }
                    }
                }
            }
        }
    }
`;

const Orders = () => {
    let token;
    if (typeof window !== 'undefined') {
        token = JSON.parse(localStorage.getItem('cid')).token;
    }
    const { loading, error, data } = useQuery(ORDERS_QUERY, {
        variables: { customerAccessToken: token },
    });

    const [orders, setOrders] = useState(-1);

    useEffect(() => {
        if (!loading) {
            // console.log(data.customer.orders.edges);
            setOrders(data.customer.orders.edges);
        }
    }, [loading]);
    return (
        <OrdersContainer>
            <SEO title="Dashboard –– Order History" />
            <div className="title-container">
                <h2>My order history</h2>
                <div className="btn-container">
                    <a href="#">Contact Support</a>
                </div>
            </div>
            <Wrapper className="table-container">
                {orders.length > 0 ? (
                    <table>
                        <thead>
                            <tr>
                                <th>Order</th>
                                <th>Date</th>
                                <th>Total</th>
                                <th>Order details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map((orderNode) => {
                                const order = orderNode.node;
                                const {
                                    orderNumber,
                                    statusUrl,
                                    processedAt,
                                    totalPriceV2,
                                } = order;

                                let price = totalPriceV2.amount;

                                let orderDate = new Date(processedAt);
                                orderDate =
                                    orderDate.getMonth() +
                                    1 +
                                    '/' +
                                    orderDate.toString().split(' ')[2] +
                                    '/' +
                                    orderDate.toString().split(' ')[3];
                                return (
                                    <tr>
                                        <td>#{orderNumber}</td>
                                        <td>{orderDate}</td>
                                        <td>${price}</td>
                                        <td>
                                            <a target="_blank" href={statusUrl}>
                                                View
                                            </a>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                ) : (
                    orders !== -1 && (
                        <div className="no-orders-container">
                            <h4>No orders yet.</h4>
                        </div>
                    )
                )}
                <table></table>
            </Wrapper>
        </OrdersContainer>
    );
};

export default Orders;
